export var CompanyStructure;
(function (CompanyStructure) {
    CompanyStructure["Corporation"] = "CORPORATION";
    CompanyStructure["Partnership"] = "PARTNERSHIP";
    CompanyStructure["SoleTrader"] = "SOLE_TRADER";
    CompanyStructure["Trust"] = "TRUST";
})(CompanyStructure || (CompanyStructure = {}));
export var CompanyType;
(function (CompanyType) {
    CompanyType["Incorporated"] = "INCORPORATED";
    CompanyType["Ltd"] = "LTD";
    CompanyType["NL"] = "NL";
    CompanyType["PtyLtd"] = "PTY_LTD";
})(CompanyType || (CompanyType = {}));
//# sourceMappingURL=Company.js.map